module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av376-2add699eca1e7019b8f5f91fedcc6fc5.jpg";